module.exports = __webpack_public_path__ + "media/images/close-btn-white-cdfe46389298032e79ca335d087d28a3.svg";